import * as types from '../actions/types';
import initialState from './initialState';



export default function studentReducer(state = initialState.group, action) {
  switch (action.type) {
    case types.GET_GROUP_BY_ID_SUCCESS:
      return {
        ...state,
        ...action.payload
      }
    case types.GET_ALL_GROUP_LOCKS_SUCCESS:
      return {
        ...state,
        locks: action.payload
      };
    case types.GET_ALL_GROUP_CONFLICTS_SUCCESS:
      return {
        ...state,
        conflicts: action.payload
      };
    case types.GET_ALL_GROUP_REQUIREMENTS_SUCCESS:
      return {
        ...state,
        requirements: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/groupReducer.js